/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { UnsplashImage } from "./data-contracts";

/**
 * No description
 * @tags internal
 * @name SignInWithEmailLink
 * @summary Send a sign-in link to the specified email address
 * @request POST:/internal/signin/email-link
 * @secure
 */

// @ts-ignore
export const signInWithEmailLink: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: {
    /** Email to send the link to. */
    email: string;
    /** URL to redirect to with the OOB code (with protocol, ex: "http://localhost:5000"). */
    url?: string;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/internal/signin/email-link",
  method: "post",
  streaming: false,
  tags: ["internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags internal
 * @name SignInMethodsForEmail
 * @summary Get supported sign in methods for an email address
 * @request GET:/internal/signin/{email}/methods
 * @secure
 */

// @ts-ignore
export const signInMethodsForEmail: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The email address to list sign in methods for */
    email: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    methods: ("emailLink" | "password" | "google.com" | "github.com")[];
    /** The ID of the organization the user has an SSO link to. */
    ssoOrganization?: string;
  };
  ResponseStatusCode: 200;
} = {
  route: "/internal/signin/{email}/methods",
  method: "get",
  streaming: false,
  tags: ["internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags internal
 * @name SearchUnsplashImages
 * @summary Search images in unsplash.
 * @request GET:/internal/unsplash/images
 * @secure
 */

// @ts-ignore
export const searchUnsplashImages: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {
    query?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: UnsplashImage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/internal/unsplash/images",
  method: "get",
  streaming: false,
  tags: ["internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Indicate the use of an unsplash image. It's a requirement as part of their API Guidelines.
 * @tags internal
 * @name TrackDownloadUnplashImage
 * @summary Track the download of an image from Unsplash
 * @request POST:/internal/unsplash/track_download
 * @secure
 */

// @ts-ignore
export const trackDownloadUnplashImage: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: {
    downloadLocation: string;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/internal/unsplash/track_download",
  method: "post",
  streaming: false,
  tags: ["internal"],
  criticalityLevel: "low",
  deprecated: false,
};
